import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
//const Dashboard = () => import('@/views/Dashboard')
const Coversations = () => import('@/views/Coversations')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/messages/0/0',
      name: 'Home',
      component: DefaultContainer,
      children: [
        /*
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        */
        {
          path: 'messages/:projectid/:conversationid?',
          name: 'Conversazioni', 
          component: Coversations
        }      
      ]
    }
  ]
})
